
import './App.less';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Home from './screens/home'
import About from './screens/about'
import Portfolio from "./screens/portfolio"
import Blog from "./screens/blog"
import Error from "./screens/error"


function App() {
  return (
    <div className="App">
    <Router>
      <Routes>
     <Route path="/"  element={<Home/>}/>
     <Route  path="/about"  element={<About/>}/>
     <Route  path="/projects"  element={<Portfolio/>}/>
     <Route  path="/blog"  element={<Blog/>}/>
     <Route path="*" element={<Error/>}/>

     </Routes>
    </Router>
    </div>

  );
}

export default App;
